<script setup lang="ts">
import SimpleButton from "@/components/ui/SimpleButton.vue";

const props = defineProps<{
  close: (result: unknown) => void;
  cancel: () => void;
}>();

const name = defineModel<string>("name", { default: "" });
</script>

<template>
  <SimpleButton @click="props.cancel" label="Cancel" kind="ghost" />
  <SimpleButton
    @click="props.close(name)"
    label="Create"
    kind="primary"
    :disabled="name.length === 0"
  />
</template>

<style scoped>
.skore-button {
  flex-grow: 1;
}
</style>
